import React from 'react';
import PropTypes from 'prop-types';

import { values } from 'ramda';
import * as linkify from 'linkifyjs';
import Linkify from 'linkifyjs/react';
import mention from 'linkifyjs/plugins/mention';

// Initializes the mention plugin for Linkify. For more information visit https://soapbox.github.io/linkifyjs/docs/plugins.html
mention(linkify);


/**
 * Basic message component that handles rendering message content.
 */
const MessageContent = ({ content, users }) => {

  /**
   * Validates a value against the mention names of the provided users.
   * @param value the @mention name
   * @returns true if the provided value matches the mention name of one of the valid users.
   */
  const validateMentionName = value => {
    const mentionName = value.substring(1);
    // Some will short-circuit when the inner function returns true.
    return values(users).some(u => {
      return u.mentionName && u.mentionName === mentionName;
    });
  };

  // For more information on Linkify options visit https://soapbox.github.io/linkifyjs/docs/options.html
  const linkifyOptions = {
    formatHref: (href, type) => {
      switch (type) {
        case 'mention':
          return '#';
        default:
          return href;
      }
    },
    validate: {
      mention: value => validateMentionName(value)
    }
  };

  return (
    <span className="message-content">
      <Linkify options={linkifyOptions}>{content}</Linkify>
    </span>
  );
};

MessageContent.propTypes = {
  content: PropTypes.string.isRequired,
  users: PropTypes.object,
};

export default MessageContent;
